const namespace = 'PAGES/BROWSE_OPERATOR_REGIONS/';

export const SELECT_CHANNEL = namespace + 'SELECT_CHANNEL';
export const SELECT_OPERATOR = namespace + 'SELECT_OPERATOR';
